import React from 'react';

const BasicRadioButton= ({id, text, isChecked, onClick, className} : {id: number, text: string, isChecked: boolean, onClick: any, className?: string}) => {   
    return (
        <span key={`basic-radio-button-${id}`} className={`basic-radio-button ${className ? className :  ""}`}>
            <input id={`radio-button-${id}`}  className="basic-radio-button-input" onChange={onClick} type="radio" checked={isChecked}/>
    
            <label htmlFor={`radio-button-${id}`} className="basic-radio-button-text">{text}</label>
        </span>
    );
}
  
export default BasicRadioButton